<div class="grid">
  <div class="grid__col-12 center-text empty-state-container">
    <img
      [alt]="i18n.Core_Empty_Image_Alt"
      [src]="emptyImageUrl | blobifyUrl: true"
      width="360px"
      height="275px"
      class="guts-p-b-2"
    />

    <p class="par font-semibold guts-p-b-quart">
      {{ [title] }}
    </p>
    <p class="par--small par--light">{{ description }}</p>
    <p
      *ngIf="helpText"
      class="par--small par--light guts-m-t-1"
      [innerHTML]="helpText"
    ></p>
  </div>
</div>
